import type { MemoBlock, MemoTemplate } from '@/shared/templates/memos'

/**
 * Where a published PM goes when inserted: the block the template pins it to,
 * or else whichever active block the editor picks. `restores` says the pinned
 * block has been removed and is put back by the insert.
 */
export type InsertTarget
  = | { kind: 'block', blockId: string, restores: boolean }
    | { kind: 'ask', blocks: MemoBlock[] }

/** See `insertableDocumentsBlock` on the template schema. */
export function insertTarget(
  template: MemoTemplate | undefined,
  activeBlocks: MemoBlock[]
): InsertTarget | undefined {
  if (!template?.insertableDocuments) {
    return undefined
  }

  const pinned = template.insertableDocumentsBlock

  if (!pinned) {
    return { kind: 'ask', blocks: activeBlocks }
  }

  return {
    kind: 'block',
    blockId: pinned,
    restores: !activeBlocks.some((block) => block.id === pinned)
  }
}
